import React, { useEffect, useState } from "react";
import { db, auth } from "./firebase";
import {
  collection,
  getDocs,
  doc,
  getDoc,
  updateDoc,
  deleteDoc,
  onSnapshot,
  serverTimestamp,
  setDoc
} from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { useSearchParams, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import "./navbar-spacing.css";
import "./Dashboard.css";

function DashboardCassa() {
  const btnCopertiControl = {
    width: "60px",
    height: "60px",
    borderRadius: "16px",
    border: "1px solid rgba(255,255,255,0.08)",
    background: "rgba(255,255,255,0.05)",
    color: "#fff",
    fontSize: "1.4rem",
    fontWeight: 700,
    cursor: "pointer",
    transition: "0.15s ease"
  };
  const [user] = useAuthState(auth);
  const [localeTag, setLocaleTag] = useState("");
  const [menu, setMenu] = useState([]);
  const [conferma, setConferma] = useState("");
  const [infoLocale, setInfoLocale] = useState({});
  const [totaleOggi, setTotaleOggi] = useState(0);
  const [tavoliAttivi, setTavoliAttivi] = useState([]);
  const [tavoliPagati, setTavoliPagati] = useState([]);
  const [viewPagati, setViewPagati] = useState(false);
  const [modaleCoperti, setModaleCoperti] = useState(null); // { ordiniIds, totale }
  const [numeroCoperti, setNumeroCoperti] = useState(1);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const tavoloFiltro = searchParams.get("tavolo"); // Legge parametro ?tavolo=X
  const [chiusuraLoading, setChiusuraLoading] = useState(false);
  const [modaleChiusuraCassa, setModaleChiusuraCassa] = useState(false);
  const [camerieriMap, setCamerieriMap] = useState({});
    const [filtroPeriodo, setFiltroPeriodo] = useState("oggi");
const [dataDa, setDataDa] = useState("");
const [dataA, setDataA] = useState("");

  // Carica i nomi dei camerieri
  useEffect(() => {
    const fetchCamerieri = async () => {
      try {
        const snapshot = await getDocs(collection(db, "camerieri"));
        const map = {};
        snapshot.docs.forEach(doc => {
          map[doc.id] = doc.data().nome;
        });
        setCamerieriMap(map);
      } catch (error) {
        console.error("Errore caricamento camerieri:", error);
      }
    };
    fetchCamerieri();
  }, []);

  useEffect(() => {
    if (!user) return;

    let unsubscribe = null;

    const init = async () => {
      const docRef = doc(db, "utenti", user.uid);
      const docSnap = await getDoc(docRef);

      if (!docSnap.exists()) return;

      const tag = docSnap.data().localeTag;
      setLocaleTag(tag);

      const localeRef = doc(db, "locali", tag);

      unsubscribe = onSnapshot(localeRef, (snap) => {
        if (!snap.exists()) return;

        const data = snap.data();
        setInfoLocale(data);

        // 🔴 BLOCCO CASSA
        if (data.nascondiCassa) {
          navigate("/");
        }
      });
    };

    init();

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [user, navigate]);

  // Carica menu per categorie (mappa nome -> categoria)
  useEffect(() => {
    const fetchMenu = async () => {
      if (!localeTag) return;
      const snap = await getDocs(collection(db, "menu"));
      const lista = snap.docs
        .map(d => ({ id: d.id, ...d.data() }))
        .filter(m => m.localeTag?.trim().toLowerCase() === localeTag.trim().toLowerCase())
        .map(m => ({ id: m.id, name: m.nome || "", categoria: m.categoria || "" }));
      setMenu(lista);
    };
    fetchMenu();
  }, [localeTag]);

    const isNelPeriodo = (timestamp) => {
    if (!timestamp?.seconds) return false;

    const dataOrdine = new Date(timestamp.seconds * 1000);
    const adesso = new Date();

        if (filtroPeriodo === "tutti") {
      return true;
    }

    if (filtroPeriodo === "oggi") {
      const inizio = new Date(adesso);
      inizio.setHours(0, 0, 0, 0);

      const fine = new Date(inizio);
      fine.setDate(fine.getDate() + 1);

      return dataOrdine >= inizio && dataOrdine < fine;
    }

    if (filtroPeriodo === "settimana") {
      const inizio = new Date(adesso);
      const giorno = inizio.getDay();
      const differenza = giorno === 0 ? -6 : 1 - giorno;

      inizio.setDate(inizio.getDate() + differenza);
      inizio.setHours(0, 0, 0, 0);

      const fine = new Date(inizio);
      fine.setDate(fine.getDate() + 7);

      return dataOrdine >= inizio && dataOrdine < fine;
    }

    if (filtroPeriodo === "mese") {
      const inizio = new Date(
        adesso.getFullYear(),
        adesso.getMonth(),
        1
      );

      const fine = new Date(
        adesso.getFullYear(),
        adesso.getMonth() + 1,
        1
      );

      return dataOrdine >= inizio && dataOrdine < fine;
    }

    if (filtroPeriodo === "intervallo" && (dataDa || dataA)) {
      let inizio = null;
      let fine = null;

      if (dataDa) {
        const [annoDa, meseDa, giornoDa] = dataDa
          .split("-")
          .map(Number);

        inizio = new Date(
          annoDa,
          meseDa - 1,
          giornoDa
        );

        inizio.setHours(0, 0, 0, 0);
      }

      if (dataA) {
        const [annoA, meseA, giornoA] = dataA
          .split("-")
          .map(Number);

        fine = new Date(
          annoA,
          meseA - 1,
          giornoA
        );

        fine.setHours(23, 59, 59, 999);
      }

      if (inizio && dataOrdine < inizio) {
        return false;
      }

      if (fine && dataOrdine > fine) {
        return false;
      }

      return true;
    }

    return true;
  };
  
  const isNelPeriodoPagamenti = (ordine) => {
    const timestampPagamento =
      ordine?.pagatoIl || ordine?.timestamp;

    if (!timestampPagamento?.seconds) return false;

    // Per settimana, mese e data scelta usa normalmente
    // il momento del pagamento, con fallback al timestamp
    // per i vecchi ordini che non hanno ancora pagatoIl
    if (filtroPeriodo !== "oggi") {
      return isNelPeriodo(timestampPagamento);
    }

    const dataPagamento = new Date(
      timestampPagamento.seconds * 1000
    );

    const inizioGiornata = new Date();
    inizioGiornata.setHours(0, 0, 0, 0);

    const fineGiornata = new Date(inizioGiornata);
    fineGiornata.setDate(fineGiornata.getDate() + 1);

    const ultimaChiusuraTs =
      infoLocale?.ultimaChiusuraCassa;

    let ultimaChiusuraDate = null;

    if (ultimaChiusuraTs) {
      if (ultimaChiusuraTs.seconds) {
        ultimaChiusuraDate = new Date(
          ultimaChiusuraTs.seconds * 1000
        );
      } else {
        ultimaChiusuraDate = new Date(
          ultimaChiusuraTs
        );
      }
    }

    const inizioPeriodo =
      ultimaChiusuraDate &&
      ultimaChiusuraDate > inizioGiornata
        ? ultimaChiusuraDate
        : inizioGiornata;

    return (
      dataPagamento >= inizioPeriodo &&
      dataPagamento < fineGiornata
    );
  };

  const getCategoriaByName = (dishName) => {
    const found = menu.find(m => m.name === dishName);
    return found?.categoria || "";
  };

  const getCategoryHue = (categoria) => {
    if (!categoria) return 0;
    let hash = 0;
    for (let i = 0; i < categoria.length; i++) {
      hash = categoria.charCodeAt(i) + ((hash << 5) - hash);
      hash |= 0;
    }
    return Math.abs(hash) % 360;
  };

  const getCategoryColor = (categoria) => {
    if (!categoria) return "#999";
    let hash = 0;
    for (let i = 0; i < categoria.length; i++) {
      hash = categoria.charCodeAt(i) + ((hash << 5) - hash);
      hash |= 0;
    }
    const hue = Math.abs(hash) % 360;
    return `hsl(${hue}, 65%, 45%)`;
  };

  const fetchOrdini = async () => {
    if (!localeTag) return;
    try {
      const querySnapshot = await getDocs(collection(db, "ordini"));
      let lista = querySnapshot.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter((o) => o.locale === localeTag);

      // Filtra per tavolo specifico se presente nel parametro URL
      if (tavoloFiltro) {
        lista = lista.filter(o => o.table === tavoloFiltro);
      }

      // Periodo generale selezionato
      const listaPeriodo = lista.filter((o) =>
        isNelPeriodo(o.timestamp)
      );

      // Periodo dei pagamenti:
      // con "oggi" parte dall'ultima chiusura cassa,
      // con gli altri filtri usa lo storico completo del periodo scelto
   const listaPeriodoPagamenti = lista.filter((o) =>
  isNelPeriodoPagamenti(o)
);

      // Incasso del periodo/sessione selezionata
      const totale = listaPeriodoPagamenti
        .filter((o) => o.stato === "pagamento")
        .reduce((sum, o) => sum + (o.totale || 0), 0);

      setTotaleOggi(totale);

       // Tavoli attivi:
      // con filtro "oggi" mostra anche tutti gli ordini non pagati dei giorni precedenti
      // con gli altri filtri usa normalmente il periodo selezionato
      const listaAttivi = listaPeriodo.filter(
        (o) =>
          o.stato !== "archiviato" &&
          o.stato !== "pagamento"
      );

      const grouped = {};

      listaAttivi.forEach((o) => {
        if (!grouped[o.table]) grouped[o.table] = [];
        grouped[o.table].push(o);
      });

      const tavoliAttiviArray = Object.keys(grouped)
        .sort((a, b) => parseInt(a) - parseInt(b))
        .map((tableNum) => {
          const ordiniTavolo = grouped[tableNum];
const isAsporto = ordiniTavolo.some((ordine) =>
  String(ordine.tipoOrdine || "").toUpperCase() === "ASPORTO" ||
  ordine.numeroOrdineAsporto != null ||
  String(ordine.table || "").toUpperCase().startsWith("ASPORTO-")
);

const numeroOrdineAsporto =
  ordiniTavolo.find((ordine) => ordine.numeroOrdineAsporto != null)
    ?.numeroOrdineAsporto ?? null;
          // Raggruppa piatti identici con modifiche (normalizzando quantità/prezzo)
          const piattiMap = {};
          ordiniTavolo.forEach((ordine) => {
            (ordine.items || []).forEach((item) => {
              const key = item.name + (item.custom ? `-${item.custom}` : "");
              const qty = item.quantity || item.quantita || 1;
              const price = item.price || item.prezzo || 0;
              if (!piattiMap[key]) {
                piattiMap[key] = {
                  ...item,
                  quantity: qty,
                  price
                };
              } else {
                piattiMap[key].quantity = (piattiMap[key].quantity || 0) + qty;
                // Se manca il prezzo, assegna quello normalizzato
                if (piattiMap[key].price == null) piattiMap[key].price = price;
              }
            });
          });

          // Determina stato tavolo attivo
          const statiAttivi = ordiniTavolo.map((o) => o.stato);
          const rank = { "inviato": 1, "in attesa": 2, "in preparazione": 3, "pronto": 4 };
          const stato = statiAttivi.length > 0
            ? statiAttivi.sort((a, b) => (rank[a] || 99) - (rank[b] || 99))[0]
            : "pronto";

          // Calcolo totale tavolo attivo (dalla somma dei piatti)
          const totaleTavolo = Object.values(piattiMap).reduce(
            (acc, it) => acc + (it.quantity || 0) * (it.price || 0),
            0
          );

return {
  table: tableNum,
  ordiniIds: ordiniTavolo.map((o) => o.id),
  items: Object.values(piattiMap),
  totale: totaleTavolo,
  stato,
  timestamp: ordiniTavolo[0].timestamp,
  cameriere_id: ordiniTavolo[0].cameriere_id || null,
  coperti: isAsporto ? 0 : (ordiniTavolo[0].coperti || 0),
  isAsporto,
  numeroOrdineAsporto
};
        });

      // Ordini pagati: LISTA SEPARATA (non raggruppati per tavolo)
      // Ogni ordine pagato è un evento distinto con il suo totale e timestamp
           const ordiniPagatiArray = listaPeriodoPagamenti
        .filter((o) => o.stato === "pagamento")
        .filter((o) => o.timestamp?.seconds)
        .sort(
  (a, b) =>
    (b.pagatoIl?.seconds ||
      b.timestamp?.seconds ||
      0) -
    (a.pagatoIl?.seconds ||
      a.timestamp?.seconds ||
      0)
)
        .map((ordine) => ({
          id: ordine.id,
          table: ordine.table,
          items: ordine.items || [],
          totale: ordine.totale || 0,
          coperti: ordine.coperti || 0,
          stato: ordine.stato,
          timestamp: ordine.pagatoIl || ordine.timestamp,
          cameriere_id: ordine.cameriere_id || null,
        }));

      setTavoliAttivi(tavoliAttiviArray);
      setTavoliPagati(ordiniPagatiArray);
    } catch (err) {
      console.error("Errore fetch ordini:", err);
    }
  };

  useEffect(() => {
    if (!localeTag) return;

    const unsub = onSnapshot(
      collection(db, "ordini"),
      (querySnapshot) => {
        try {
          let lista = querySnapshot.docs
            .map((doc) => ({ id: doc.id, ...doc.data() }))
            .filter((o) => o.locale === localeTag);

          // Filtra per tavolo specifico se presente nel parametro URL
          if (tavoloFiltro) {
            lista = lista.filter((o) => o.table === tavoloFiltro);
          }

          // Periodo generale selezionato
          const listaPeriodo = lista.filter((o) =>
            isNelPeriodo(o.timestamp)
          );

          // Periodo dei pagamenti:
          // con "oggi" parte dall'ultima chiusura cassa
        const listaPeriodoPagamenti = lista.filter((o) =>
  isNelPeriodoPagamenti(o)
);

          // Incasso della sessione/periodo selezionato
          const totale = listaPeriodoPagamenti
            .filter((o) => o.stato === "pagamento")
            .reduce((sum, o) => sum + (o.totale || 0), 0);

          setTotaleOggi(totale);

          // Tavoli attivi:
          // con filtro "oggi" mostra anche tutti gli ordini non pagati dei giorni precedenti
          // con gli altri filtri usa normalmente il periodo selezionato
          const listaAttivi = listaPeriodo.filter(
            (o) =>
              o.stato !== "archiviato" &&
              o.stato !== "pagamento"
          );

          const grouped = {};

          listaAttivi.forEach((o) => {
            if (!grouped[o.table]) grouped[o.table] = [];
            grouped[o.table].push(o);
          });

          const tavoliAttiviArray = Object.keys(grouped)
            .sort((a, b) => parseInt(a) - parseInt(b))
            .map((tableNum) => {
              const ordiniTavolo = grouped[tableNum];

              const isAsporto = ordiniTavolo.some(
                (ordine) =>
                  String(ordine.tipoOrdine || "").toUpperCase() ===
                    "ASPORTO" ||
                  ordine.numeroOrdineAsporto != null ||
                  String(ordine.table || "")
                    .toUpperCase()
                    .startsWith("ASPORTO-")
              );

              const numeroOrdineAsporto =
                ordiniTavolo.find(
                  (ordine) =>
                    ordine.numeroOrdineAsporto != null
                )?.numeroOrdineAsporto ?? null;

              // Raggruppa piatti identici con modifiche
              const piattiMap = {};

              ordiniTavolo.forEach((ordine) => {
                (ordine.items || []).forEach((item) => {
                  const key =
                    item.name +
                    (item.custom ? `-${item.custom}` : "");

                  const qty =
                    item.quantity || item.quantita || 1;

                  const price =
                    item.price || item.prezzo || 0;

                  if (!piattiMap[key]) {
                    piattiMap[key] = {
                      ...item,
                      quantity: qty,
                      price
                    };
                  } else {
                    piattiMap[key].quantity =
                      (piattiMap[key].quantity || 0) + qty;

                    if (piattiMap[key].price == null) {
                      piattiMap[key].price = price;
                    }
                  }
                });
              });

              // Determina stato tavolo attivo
              const statiAttivi = ordiniTavolo.map(
                (o) => o.stato
              );

              const rank = {
                inviato: 1,
                "in attesa": 2,
                "in preparazione": 3,
                pronto: 4
              };

              const stato =
                statiAttivi.length > 0
                  ? statiAttivi.sort(
                      (a, b) =>
                        (rank[a] || 99) -
                        (rank[b] || 99)
                    )[0]
                  : "pronto";

              // Calcolo totale tavolo attivo
              const totaleTavolo = Object.values(
                piattiMap
              ).reduce(
                (acc, it) =>
                  acc +
                  (it.quantity || 0) *
                    (it.price || 0),
                0
              );

              return {
                table: tableNum,
                ordiniIds: ordiniTavolo.map(
                  (o) => o.id
                ),
                items: Object.values(piattiMap),
                totale: totaleTavolo,
                stato,
                timestamp:
                  ordiniTavolo[0].timestamp,
                cameriere_id:
                  ordiniTavolo[0].cameriere_id ||
                  null,
                coperti: isAsporto
                  ? 0
                  : ordiniTavolo[0].coperti || 0,
                isAsporto,
                numeroOrdineAsporto
              };
            });

          // Ordini pagati nel periodo selezionato
                    const ordiniPagatiArray =
            listaPeriodoPagamenti
              .filter(
                (o) => o.stato === "pagamento"
              )
              .filter((o) => o.timestamp?.seconds)
             .sort(
  (a, b) =>
    (b.pagatoIl?.seconds ||
      b.timestamp?.seconds ||
      0) -
    (a.pagatoIl?.seconds ||
      a.timestamp?.seconds ||
      0)
)
              .map((ordine) => ({
                id: ordine.id,
                table: ordine.table,
                items: ordine.items || [],
                totale: ordine.totale || 0,
                coperti: ordine.coperti || 0,
                stato: ordine.stato,
                timestamp: ordine.pagatoIl || ordine.timestamp,
                cameriere_id:
                  ordine.cameriere_id || null
              }));

          setTavoliAttivi(tavoliAttiviArray);
          setTavoliPagati(ordiniPagatiArray);
        } catch (err) {
          console.error(
            "Errore realtime ordini:",
            err
          );
        }
      },
      (err) =>
        console.error(
          "Errore onSnapshot ordini:",
          err
        )
    );

    return () => unsub();
   }, [
  localeTag,
  tavoloFiltro,
  filtroPeriodo,
  dataDa,
  dataA,
  infoLocale?.ultimaChiusuraCassa
]);

  const chiudiCassa = async () => {
    if (!localeTag || chiusuraLoading) return;

    setModaleChiusuraCassa(false);
    setChiusuraLoading(true);

    try {
      await updateDoc(doc(db, "locali", localeTag), { ultimaChiusuraCassa: serverTimestamp() });
      // Aggiorna subito lo stato locale per riflettere la chiusura senza attendere roundtrip
      setInfoLocale((prev) => ({ ...prev, ultimaChiusuraCassa: new Date() }));
     setConferma("✅ Cassa chiusa. Nuova sessione di cassa avviata.");
      setTimeout(() => setConferma(""), 3000);
    } catch (e) {
      console.error("Errore chiusura cassa:", e);
      setConferma("❌ Errore durante la chiusura cassa");
      setTimeout(() => setConferma(""), 3000);
    } finally {
      setChiusuraLoading(false);
    }
  };

  // Helper: sincronizza la copia "pubblica" in ordiniTemp/{normalizedLocale}_{table}/sent
  // Elimina i documenti invece di aggiornarli per garantire che i clienti non vedano ordini vecchi
  const aggiornaOrdiniTempSent = async (tableNumber, nuovoStato) => {
    try {
      if (!localeTag) return;
      const normalized = String(localeTag).toLowerCase().replace(/[^a-z0-9]/gi, "");
      const sentColPath = `ordiniTemp/${normalized}_${tableNumber}/sent`;
      const sentSnapshot = await getDocs(collection(db, sentColPath));
      
      // Se lo stato è pagamento o archiviato, elimina tutti i documenti sent
      if (nuovoStato === "pagamento" || nuovoStato === "archiviato") {
        for (const sDoc of sentSnapshot.docs) {
          try {
            await deleteDoc(doc(db, sentColPath, sDoc.id));
          } catch (e) {
            console.debug("Impossibile eliminare sent doc:", sDoc.id, e?.message || e);
          }
        }
      } else {
        // Per altri stati, aggiorna normalmente
        for (const sDoc of sentSnapshot.docs) {
          try {
            await updateDoc(doc(db, sentColPath, sDoc.id), { stato: nuovoStato });
          } catch (e) {
            console.debug("Impossibile aggiornare sent doc:", sDoc.id, e?.message || e);
          }
        }
      }
    } catch (err) {
      console.error("Errore sincronizzazione ordiniTemp sent:", err);
    }
  };

  const aggiornaStatoTavolo = async (ordiniIds, nuovoStato, tableNumber = null, coperti = null) => {
    try {
      for (const id of ordiniIds) {
        const updateData = { stato: nuovoStato };
        if (coperti !== null) {
          updateData.coperti = coperti;
        }
        await updateDoc(doc(db, "ordini", id), updateData);
      }
      // Aggiorna anche la copia pubblica (se conosciamo il numero tavolo)
      if (tableNumber) await aggiornaOrdiniTempSent(tableNumber, nuovoStato);

      setConferma(
        nuovoStato === "pagamento"
          ? "✅ Tavolo segnato come pagato"
          : "✅ Tavolo liberato"
      );
      setTimeout(() => setConferma(""), 3000);
      fetchOrdini();
    } catch (err) {
      console.error("❌ Errore aggiornamento stato tavolo:", err);
      setConferma("❌ Errore aggiornamento stato");
      setTimeout(() => setConferma(""), 3000);
    }
  };

const confermaPagamentoAsporto = async (tavolo) => {
  if (!tavolo?.ordiniIds?.length) return;

  try {
    // Aggiorna l'ordine usato da cucina e cassa
    for (const id of tavolo.ordiniIds) {
 await updateDoc(doc(db, "ordini", id), {
  stato: "pagamento",
  coperti: 0,
  pagatoIl: serverTimestamp()
});
    }

    // Aggiorna anche il documento usato dal cliente per il tracking
    if (tavolo.numeroOrdineAsporto != null) {
      const normalized = String(localeTag)
        .toLowerCase()
        .replace(/[^a-z0-9]/gi, "");

      const ordineAsportoRef = doc(
        db,
        "ordini_asporto",
        `${normalized}_${tavolo.numeroOrdineAsporto}`
      );

      await setDoc(
        ordineAsportoRef,
        {
          stato: "pagamento",
          coperti: 0,
          pagatoIl: serverTimestamp()
        },
        { merge: true }
      );
    }

    setConferma(
      `✅ Ordine asporto #${tavolo.numeroOrdineAsporto || ""} segnato come pagato`
    );

    setTimeout(() => setConferma(""), 3000);
    fetchOrdini();
    setModaleCoperti(null);
setNumeroCoperti(1);
  } catch (err) {
    console.error("❌ Errore pagamento ordine da asporto:", err);
    setConferma("❌ Errore aggiornamento pagamento");
    setTimeout(() => setConferma(""), 3000);
  }
};

  const confermaPagamento = async () => {
    if (!modaleCoperti || numeroCoperti < 1) return;
    
    // Calcola il costo dei coperti
    const prezzoCoperto = infoLocale.prezzoCoperto || 0;
    const costoCoperti = numeroCoperti * prezzoCoperto;
    const totaleConCoperti = modaleCoperti.totale + costoCoperti;
    
    try {
      for (const id of modaleCoperti.ordiniIds) {
await updateDoc(doc(db, "ordini", id), {
  stato: "pagamento",
  coperti: numeroCoperti,
  totale:
    totaleConCoperti /
    modaleCoperti.ordiniIds.length,
  pagatoIl: serverTimestamp()
});
      }
      // Aggiorna anche la copia pubblica degli ordini per quel tavolo
      if (modaleCoperti?.table) {
        try {
          await aggiornaOrdiniTempSent(modaleCoperti.table, "pagamento");
        } catch (e) {
          console.debug("Errore aggiornamento ordiniTemp sent dopo pagamento:", e?.message || e);
        }
      }
      // RIGENERA TOKEN DOPO PAGAMENTO
      console.log("Rigenerazione token tavolo", modaleCoperti.table);
      const nuovoToken = generaTokenCasuale();
      console.log("Nuovo token generato:", nuovoToken);
      
      const tavoloRef = doc(db, "locali", localeTag, "tavoli", modaleCoperti.table);
      const tavoloSnap = await getDoc(tavoloRef);
      
      if (tavoloSnap.exists()) {
        await updateDoc(tavoloRef, {
          tokenAttuale: nuovoToken,
          ultimoAggiornamento: serverTimestamp()
        });
        console.log("Token aggiornato per tavolo", modaleCoperti.table);
      } else {
        await setDoc(tavoloRef, {
          numero: modaleCoperti.table,
          tokenAttuale: nuovoToken,
          ultimoAggiornamento: serverTimestamp()
        });
        console.log("Token creato per tavolo", modaleCoperti.table);
      }
      
      setConferma("✅ Tavolo " + modaleCoperti.table + " pagato. Token aggiornato.");
      setTimeout(() => setConferma(""), 3000);
      fetchOrdini();
    } catch (err) {
      console.error("❌ Errore aggiornamento stato tavolo:", err);
      setConferma("❌ Errore aggiornamento stato");
      setTimeout(() => setConferma(""), 3000);
    }
    
    setModaleCoperti(null);
    setNumeroCoperti(1);
  };

  const tavoliDaMostrare = viewPagati ? tavoliPagati : tavoliAttivi;

  // Helper per generare token casuale
  const generaTokenCasuale = () => {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  };

  return (
    <>
      <Navbar />
  <div className="container page-with-navbar" style={{ maxWidth: "1400px", margin: "0 auto", boxSizing: "border-box" }}>
       

        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1rem" }}>
          <h2 style={{ margin: 0 }}>
            💰 {tavoloFiltro ? `Cassa Tavolo ${tavoloFiltro}` : "Dashboard Cassa"}
          </h2>
          <div style={{ display: "flex", gap: "0.5rem" }}>
            {tavoloFiltro && (
              <button
                onClick={() => navigate("/dashboard-cassa")}
                style={{
                  padding: "0.5rem 1rem",
                  backgroundColor: "#f5f5f5",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontSize: "0.9rem",
                  color: "#000"
                }}
              >
                ← Tutti i tavoli
              </button>
            )}
<button
  onClick={() => setModaleChiusuraCassa(true)}
  disabled={chiusuraLoading}
  title="Chiude la sessione di cassa corrente senza eliminare gli ordini non pagati"
  style={{
    padding: "0.6rem 1rem",
    background: chiusuraLoading
      ? "rgba(255,255,255,0.08)"
      : "rgba(255,255,255,0.06)",
    color: chiusuraLoading ? "#777" : "#fff",
    border: "1px solid rgba(255,255,255,0.12)",
    borderRadius: "10px",
    cursor: chiusuraLoading ? "not-allowed" : "pointer",
    fontSize: "0.9rem",
    fontWeight: 600,
    transition: "0.15s ease"
  }}
>
  {chiusuraLoading ? "Chiusura..." : "🔒 Chiudi cassa"}
</button>
          </div>
        </div>

        <div style={{ marginBottom: "1rem" }}>
          <button
            onClick={() => setViewPagati(false)}
            className={`tab-switch ${!viewPagati ? "tab-active" : "tab-inactive"}`}
            style={{ marginRight: "1rem" }}
          >
            Tavoli attivi
          </button>
          <button
            onClick={() => setViewPagati(true)}
            className={`tab-switch ${viewPagati ? "tab-active" : "tab-inactive"}`}
          >
            Tavoli pagati
          </button>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "0.5rem",
            marginBottom: "1rem"
          }}
        >
                    <button
            onClick={() => setFiltroPeriodo("tutti")}
            className={`tab-switch ${
              filtroPeriodo === "tutti" ? "tab-active" : "tab-inactive"
            }`}
          >
            Tutti
          </button>

          <button
            onClick={() => setFiltroPeriodo("oggi")}
            className={`tab-switch ${
              filtroPeriodo === "oggi" ? "tab-active" : "tab-inactive"
            }`}
          >
            Oggi
          </button>

          <button
            onClick={() => setFiltroPeriodo("settimana")}
            className={`tab-switch ${
              filtroPeriodo === "settimana" ? "tab-active" : "tab-inactive"
            }`}
          >
            Questa settimana
          </button>

          <button
            onClick={() => setFiltroPeriodo("mese")}
            className={`tab-switch ${
              filtroPeriodo === "mese" ? "tab-active" : "tab-inactive"
            }`}
          >
            Questo mese
          </button>

<button
  onClick={() => setFiltroPeriodo("intervallo")}
  className={`tab-switch ${
    filtroPeriodo === "intervallo"
      ? "tab-active"
      : "tab-inactive"
  }`}
>
  Scegli da - a
</button>


{filtroPeriodo === "intervallo" && (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "0.5rem",
      flexWrap: "wrap"
    }}
  >
    <label
      style={{
        display: "flex",
        alignItems: "center",
        gap: "0.4rem",
        color: "#ccc",
        fontSize: "0.85rem"
      }}
    >
      Da

      <input
        type="date"
        value={dataDa}
        onChange={(e) => {
          const nuovaDataDa = e.target.value;
          setDataDa(nuovaDataDa);

          if (
            dataA &&
            nuovaDataDa &&
            dataA < nuovaDataDa
          ) {
            setDataA("");
          }
        }}
        style={{
          padding: "0.55rem 0.8rem",
          borderRadius: "8px",
          border: "1px solid #444",
          background: "#222",
          color: "#fff",
          fontSize: "0.9rem"
        }}
      />
    </label>

    <label
      style={{
        display: "flex",
        alignItems: "center",
        gap: "0.4rem",
        color: "#ccc",
        fontSize: "0.85rem"
      }}
    >
      A

      <input
        type="date"
        value={dataA}
        min={dataDa || undefined}
        onChange={(e) => setDataA(e.target.value)}
        style={{
          padding: "0.55rem 0.8rem",
          borderRadius: "8px",
          border: "1px solid #444",
          background: "#222",
          color: "#fff",
          fontSize: "0.9rem"
        }}
      />
    </label>

    {(dataDa || dataA) && (
      <button
        type="button"
        onClick={() => {
          setDataDa("");
          setDataA("");
        }}
        style={{
          padding: "0.55rem 0.8rem",
          borderRadius: "8px",
          border: "1px solid rgba(255,255,255,0.12)",
          background: "rgba(255,255,255,0.06)",
          color: "#fff",
          cursor: "pointer",
          fontSize: "0.85rem"
        }}
      >
        Azzera date
      </button>
    )}
  </div>
)}
        </div>

        {conferma && (
          <div style={{
            backgroundColor: "#4CAF50",
            color: "white",
            padding: "0.8rem",
            borderRadius: "8px",
            marginBottom: "1rem",
            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
            textAlign: "center"
          }}>
            {conferma}
          </div>
        )}

{filtroPeriodo !== "tutti" && (
  <p style={{ fontWeight: "bold", marginBottom: "1rem" }}>
    💶 {filtroPeriodo === "oggi"
      ? "Incasso sessione corrente"
      : "Incasso periodo selezionato"}: €{totaleOggi.toFixed(2)}
  </p>
)}

        {tavoliDaMostrare.length === 0 ? (
          <p>✅ Nessun {viewPagati ? "ordine pagato" : "tavolo attivo"} da mostrare.</p>
        ) : (
          <div className="orders-grid-container">
            {tavoliDaMostrare.map((tavolo) => (
              <div
                key={viewPagati ? tavolo.id : tavolo.table}
                className={`ordine-card stato-${tavolo.stato.replace(/\s/g, "-")}`}
              >
                <div className="ordine-header">
<div
  className="ordine-top-row"
  style={{
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: "0.5rem",
    flexWrap: "wrap",
    width: "100%"
  }}
>
  <div
    className="ordine-numero"
    style={{
      minWidth: 0,
      flex: "1 1 140px",
      overflowWrap: "anywhere",
      wordBreak: "break-word"
    }}
  >
    {viewPagati
      ? `🧾 Tavolo ${tavolo.table}`
      : `🪑 Tavolo ${tavolo.table}`}
  </div>

  {!viewPagati && (
    <span
      className={`ordine-stato stato-${tavolo.stato.replace(/\s/g, "-")}`}
      style={{
        flexShrink: 0,
        maxWidth: "100%",
        whiteSpace: "normal",
        textAlign: "center",
        overflowWrap: "anywhere"
      }}
    >
      {tavolo.stato}
    </span>
  )}
</div>

                  <div className="ordine-info">
                    💶 Totale: <strong>€{tavolo.totale.toFixed(2)}</strong>

                    {tavolo.coperti > 0 && <> • 👥 {tavolo.coperti} coperti</>}

                    {viewPagati && tavolo.timestamp && (
                      <> • 🕐 {new Date(tavolo.timestamp.seconds * 1000).toLocaleTimeString("it-IT", {
                        hour: "2-digit",
                        minute: "2-digit"
                      })}</>
                    )}
                  </div>
                </div>

                <div className="ordine-body">
                  <ul className="tight-list">
                    {tavolo.items.map((item, i) => (
                   <li
  key={i}
  className="piatto-riga"
  style={{
    overflowWrap: "anywhere",
    wordBreak: "break-word"
  }}
>
  {item.quantity} × {item.name}
  {item.custom && ` (${item.custom})`}
</li>
                    ))}
                  </ul>
                </div>

                {!viewPagati && (
                  <div className="azioni-ordine">
                    {tavolo.stato !== "pagamento" && (
<button
  className="btn-stato btn-pagamento"
  onClick={() => {
    if (tavolo.isAsporto) {
      setModaleCoperti({
        ordiniIds: tavolo.ordiniIds,
        totale: tavolo.totale,
        table: tavolo.table,
        isAsporto: true,
        numeroOrdineAsporto: tavolo.numeroOrdineAsporto
      });

      return;
    }

    setNumeroCoperti(tavolo.coperti > 0 ? tavolo.coperti : 1);

    setModaleCoperti({
      ordiniIds: tavolo.ordiniIds,
      totale: tavolo.totale,
      table: tavolo.table,
      isAsporto: false
    });
  }}
>
  💰 Segna come pagato
</button>
                    )}

                    {tavolo.stato === "pagamento" && (
                      <button
                        className="btn-stato"
                        onClick={() =>
                          aggiornaStatoTavolo(
                            tavolo.ordiniIds,
                            "archiviato",
                            tavolo.table
                          )
                        }
                      >
                        🔓 Libera tavolo
                      </button>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        {/* Modale chiusura cassa */}
        {modaleChiusuraCassa && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.65)",
              backdropFilter: "blur(6px)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "24px",
              zIndex: 1000001,
              animation: "fadeIn 0.2s ease"
            }}
          >
            <div
              style={{
                background: "#111217",
                borderRadius: "20px",
                padding: "2rem",
                width: "95%",
                maxWidth: "420px",
                boxShadow:
                  "0 20px 50px rgba(0,0,0,0.6)",
                border:
                  "1px solid rgba(255,255,255,0.08)",
                animation: "scaleIn 0.2s ease"
              }}
            >
              <h3
                style={{
                  margin: "0 0 1rem",
                  color: "#fff",
                  fontSize: "1.2rem",
                  fontWeight: 600
                }}
              >
                🔒 Chiudi cassa
              </h3>

              <p
                style={{
                  color: "#ccc",
                  lineHeight: 1.5,
                  marginBottom: "1rem"
                }}
              >
                Confermi la chiusura della sessione di
                cassa corrente?
              </p>

              <div
                style={{
                  background:
                    "rgba(255,255,255,0.04)",
                  border:
                    "1px solid rgba(255,255,255,0.06)",
                  borderRadius: "14px",
                  padding: "1rem",
                  marginBottom: "1.5rem"
                }}
              >
                <p
                  style={{
                    color: "#bbb",
                    margin: "0 0 0.7rem",
                    lineHeight: 1.5
                  }}
                >
                  L'incasso e i pagamenti della sessione
                  corrente verranno azzerati dalla vista.
                </p>

                <p
                  style={{
                    color: "#4CAF50",
                    margin: 0,
                    lineHeight: 1.5,
                    fontWeight: 600
                  }}
                >
                  ✓ Gli ordini ancora non pagati resteranno
                  attivi.
                </p>
              </div>

              <div
                style={{
                  display: "flex",
                  gap: "0.5rem"
                }}
              >
                <button
                  onClick={() =>
                    setModaleChiusuraCassa(false)
                  }
                  style={{
                    flex: 1,
                    background:
                      "rgba(255,255,255,0.06)",
                    color: "#fff",
                    border: "none",
                    padding: "0.9rem",
                    borderRadius: "14px",
                    cursor: "pointer",
                    fontWeight: 600
                  }}
                >
                  Annulla
                </button>

                <button
                  onClick={chiudiCassa}
                  disabled={chiusuraLoading}
                  style={{
                    flex: 1,
                    background:
                      "linear-gradient(135deg,#4CAF50,#2E7D32)",
                    color: "#fff",
                    border: "none",
                    padding: "0.9rem",
                    borderRadius: "14px",
                    cursor: chiusuraLoading
                      ? "not-allowed"
                      : "pointer",
                    fontWeight: 700,
                    opacity: chiusuraLoading
                      ? 0.6
                      : 1,
                    boxShadow:
                      "0 8px 20px rgba(76,175,80,0.3)"
                  }}
                >
                  {chiusuraLoading
                    ? "Chiusura..."
                    : "Conferma chiusura"}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modale coperti */}
        {modaleCoperti && (
          <div style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.65)",
            backdropFilter: "blur(6px)",
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center",
            paddingTop: "calc(var(--navbar-height-mobile, 56px) + 24px)",
            paddingBottom: "24px",
            overflowY: "auto",
            zIndex: 1000001,
            animation: "fadeIn 0.2s ease"
          }}>
            <div style={{
              background: "#111217",
              borderRadius: "20px",
              padding: "2rem",
              width: "95%",
              maxWidth: "420px",
              boxShadow: "0 20px 50px rgba(0,0,0,0.6)",
              border: "1px solid rgba(255,255,255,0.08)",
              animation: "scaleIn 0.2s ease"
            }}>
              <h3 style={{
                marginBottom: "1.5rem",
                color: "#fff",
                fontSize: "1.2rem",
                fontWeight: 600
              }}>
              {modaleCoperti.isAsporto
  ? `🥡 Riepilogo ordine asporto #${modaleCoperti.numeroOrdineAsporto}`
  : `👥 Numero Coperti - Tavolo ${modaleCoperti.table}`
}
              </h3>
              
              <div style={{
                background: "rgba(255,255,255,0.04)",
                padding: "1rem",
                borderRadius: "14px",
                marginBottom: "1.5rem",
                border: "1px solid rgba(255,255,255,0.06)"
              }}>
                <p style={{ marginBottom: "0.5rem", color: "#bbb" }}>
                  Totale ordini: <strong style={{ color: "#fff" }}>€{modaleCoperti.totale.toFixed(2)}</strong>
                </p>

                {!modaleCoperti.isAsporto && infoLocale.prezzoCoperto > 0 && (
                  <>
                    <p style={{ marginBottom: "0.5rem", color: "#bbb" }}>
                      Coperti ({numeroCoperti} × €{infoLocale.prezzoCoperto.toFixed(2)})
                    </p>

                    <div style={{
                      borderTop: "1px solid rgba(255,255,255,0.1)",
                      paddingTop: "0.8rem",
                      marginTop: "0.8rem"
                    }}>
                      <p style={{
                        fontSize: "1.2rem",
                        fontWeight: 700,
                        color: "#4CAF50",
                        margin: 0
                      }}>
                        Totale finale: €{(modaleCoperti.totale + (numeroCoperti * infoLocale.prezzoCoperto)).toFixed(2)}
                      </p>
                    </div>
                  </>
                )}
              </div>

{!modaleCoperti.isAsporto && (
  <>
    {/* Selettore coperti */}
    <div style={{ marginBottom: "1.5rem" }}>
      <p style={{
        marginBottom: "0.8rem",
        fontWeight: 600,
        color: "#ccc"
      }}>
        Quante persone al tavolo?
      </p>

      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "0.8rem",
        marginBottom: "1rem"
      }}>
        <button
          onClick={() =>
            setNumeroCoperti(prev =>
              Math.max(1, (parseInt(prev) || 1) - 1)
            )
          }
          style={btnCopertiControl}
        >
          ➖
        </button>

        <div style={{
          flex: 1,
          textAlign: "center",
          fontSize: "1.8rem",
          fontWeight: 700,
          color: "#fff"
        }}>
          {numeroCoperti}
        </div>

        <button
          onClick={() =>
            setNumeroCoperti(prev =>
              Math.min(20, (parseInt(prev) || 1) + 1)
            )
          }
          style={btnCopertiControl}
        >
          ➕
        </button>
      </div>

      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(6, 1fr)",
        gap: "0.5rem"
      }}>
        {[...Array(12)].map((_, i) => {
          const num = i + 1;
          const active = numeroCoperti === num;

          return (
            <button
              key={num}
              onClick={() => setNumeroCoperti(num)}
              style={{
                padding: "0.6rem",
                borderRadius: "10px",
                border: "1px solid rgba(255,255,255,0.08)",
                background: active
                  ? "linear-gradient(135deg,#4CAF50,#2E7D32)"
                  : "rgba(255,255,255,0.05)",
                color: active ? "#fff" : "#ccc",
                fontWeight: 600,
                cursor: "pointer",
                transition: "0.15s ease"
              }}
            >
              {num}
            </button>
          );
        })}
      </div>
    </div>
  </>
)}

{!modaleCoperti.isAsporto && (
  <p style={{
    color: "#8B7355",
    fontSize: "0.9rem",
    marginBottom: "1.5rem",
    fontStyle: "italic"
  }}>
    💡 Media per persona: €
    {numeroCoperti > 0
      ? (
          (
            modaleCoperti.totale +
            numeroCoperti * (infoLocale.prezzoCoperto || 0)
          ) / numeroCoperti
        ).toFixed(2)
      : "0.00"
    }
  </p>
)}

              <div style={{ display: "flex", gap: "0.5rem" }}>
                <button
                  onClick={() => {
                    setModaleCoperti(null);
                    setNumeroCoperti(1);
                  }}
                  style={{
                    flex: 1,
                    background: "rgba(255,255,255,0.06)",
                    color: "#fff",
                    border: "none",
                    padding: "0.9rem",
                    borderRadius: "14px",
                    cursor: "pointer",
                    fontWeight: 600
                  }}
                >
                  ❌ Annulla
                </button>
  <button
  onClick={() => {
    if (modaleCoperti.isAsporto) {
      confermaPagamentoAsporto(modaleCoperti);
    } else {
      confermaPagamento();
    }
  }}
  disabled={!modaleCoperti.isAsporto && numeroCoperti < 1}
                  style={{
                    flex: 1,
  background:
  !modaleCoperti.isAsporto && numeroCoperti < 1
    ? "#333"
    : "linear-gradient(135deg,#4CAF50,#2E7D32)",
                    color: "white",
                    border: "none",
                    padding: "0.9rem",
                    borderRadius: "14px",
                    cursor:
  !modaleCoperti.isAsporto && numeroCoperti < 1
    ? "not-allowed"
    : "pointer",
                    fontWeight: 700,
                    boxShadow:
  !modaleCoperti.isAsporto && numeroCoperti < 1
    ? "none"
    : "0 8px 20px rgba(76,175,80,0.3)"
                  }}
                >
                  ✅ Conferma pagamento
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default DashboardCassa;
